/**
 * PrimeFaces Olympos Layout
 */
var Olympos = {

  init: function () {
    this.menuWrapper = $('#layout-menu-cover');
    this.menu = $('#layout-menu');
    this.menulinks = this.menu.find('a.menulink');
    this.menuResizeButton = $('#menu-resize-btn');
    this.menuPopupButton = $('#mobile-menu-btn');
    this.layoutTabmenu = $('#layout-tab-menu');
    this.layoutSubmenus = this.menuWrapper.find('.layout-tab-submenu');
    this.body = $('body');
    this.expandedMenuitems = this.expandedMenuitems || [];
    this.layoutMenuClick = false;

    this.bindEvents();


  },

  bindEvents: function () {
    var $this = this;

    this.equalizeTabMenuHeights();
    $(".nano").nanoScroller({ flash: true });

    // open layout tab menu sub menus
    this.layoutTabmenu.find('a').off('click').on('click', function () {
      $this.layoutTabmenu.find('li a').removeClass('active');
      $(this).addClass('active');
      $this.layoutSubmenus.removeClass('active');
      $('#' + String($(this).attr('rel'))).addClass('active');

      $this.equalizeTabMenuHeights();
    });

    // change menu mode from expanded to slim
    this.menuResizeButton.off('click').on('click', function () {
      if ($this.body.hasClass('SlimMenu')) {
        $(this).removeClass('active');
        $this.body.removeClass('SlimMenu');
      }
      else {
        $(this).addClass('active');
        $this.body.addClass('SlimMenu');
      }
    });

    // show and hide popup main menu when click a menu button
    this.menuPopupButton.off('click.popupMenubutton').on('click.popupMenubutton', function (e) {
      $this.layoutMenuClick = true;
      //Commented below lines for Bug id : 126300
      //if($this.menuWrapper.hasClass('active')) {
      //    $(this).removeClass('active');
      //    $this.menuWrapper.removeClass('active');
      //}
      //else {
      //    $(this).addClass('active');
      //    $this.menuWrapper.addClass('active');
      //}

      e.preventDefault();

    });


    this.menulinks.off('click').on('click', function (e) {
      var menuitemLink = $(this),
      menuitem = menuitemLink.parent(),
      parentSubmenu = menuitem.parent('ul').parent('li').closest('ul');

      if (menuitem.hasClass('active-menu-parent')) {
        $this.unhighlightMenuitem(menuitem);
      }
      else {
        if (menuitem.parent().is('ul.active-menu')) {
          var activeSibling = menuitem.siblings('.active-menu-parent');
          $this.unhighlightMenuitem(activeSibling);
        }
        else {
          var activeItem = $this.menu.find('.active-menu-parent');
          $this.unhighlightMenuitem(activeItem);
        }

        menuitem.addClass('active-menu-parent');
        menuitemLink.addClass('active-menu').next('ul').addClass('active-menu');
      }

      if (menuitemLink.next().is('ul')) {
        e.preventDefault();
      }

      $this.equalizeTabMenuHeights();
    });

    this.menuWrapper.off('click').on('click', function () {
      $this.layoutMenuClick = true;
    });

    this.clickNS = 'click.' + this.id;
    $(document.body).off(this.clickNS).on(this.clickNS, function (e) {
      var isPopup = ($this.body.hasClass('PopupMenu') || document.documentElement.clientWidth <= 960);
      try {
        var target = $(e.target);
        if (target.context.offsetParent.id == "layout-tab-menu") {
          $this.layoutMenuClick = true;
        }
      }
      catch (err) {
      }
      if (!$this.layoutMenuClick && isPopup) {
        $this.menuPopupButton.removeClass('active');
        //$this.menuWrapper.removeClass('active');
        $("#layout-menu-cover").removeClass('active');
      }

      $this.layoutMenuClick = false;
    });
  },

  unhighlightMenuitem: function (item) {
    if (item && item.length) {
      item.removeClass('active-menu-parent');

      this.unhighlightDescendants(item);
    }
  },

  unhighlightDescendants: function (item) {
    if (item && item.length) {
      item.find('ul.active-menu,a.active-menu').removeClass('active-menu');
      item.find('li.active-menu-parent').each(function () {
        var menuitem = $(this);
        menuitem.removeClass('active-menu-parent');
      });
    }
  },

  equalizeTabMenuHeights: function () {
    var activeTabMenuMaxHeight = 0,
        $this = this;

    this.layoutSubmenus.height('auto');
    // this.layoutTabmenu.height('auto');//MM- Auto prevents sizing of menu

    this.layoutSubmenus.each(function () {
      var submenu = $(this);
      if (submenu.hasClass('active') && submenu.height() > activeTabMenuMaxHeight) {
        activeTabMenuMaxHeight = submenu.height();

        if ($this.layoutTabmenu.height() < activeTabMenuMaxHeight) {
          $this.layoutTabmenu.height(activeTabMenuMaxHeight);
        }
      }
    });

    $(".nano").nanoScroller();
  },

  isMobile: function () {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent));
  },

  changeBodyClass: function (changedClass) {
    var bodyClasses = this.body.attr('class') || '';

    if (changedClass === "") {
      changedClass = bodyClasses.replace("SlimMenu", "").replace("PopupMenu", "");
    }
    else if (changedClass === "SlimMenu") {
      bodyClasses = bodyClasses.replace("PopupMenu", "");
      changedClass = bodyClasses + " " + changedClass;
    }
    else if (changedClass === "PopupMenu") {
      bodyClasses = bodyClasses.replace("SlimMenu", "");
      changedClass = bodyClasses + " " + changedClass;
    }
    else {
      if (bodyClasses.indexOf("SlimMenu") >= 0) {
        changedClass = changedClass + " SlimMenu";
      }
      else if (bodyClasses.indexOf("PopupMenu") >= 0) {
        changedClass = changedClass + " PopupMenu";
      }
    }

    this.body.removeClass().addClass(changedClass);
    this.menuPopupButton.removeClass('active');
    this.menuResizeButton.removeClass('active');
  },

  // change menu mode from expanded to slim
  toggleMenu: function () {
    var $this = this;
    if ($this.body.hasClass('SlimMenu')) {
      $(this).removeClass('active');
      $this.body.removeClass('SlimMenu');
    }
    else {
      $(this).addClass('active');
      $this.body.addClass('SlimMenu');
    }
  }

};



// WEBPACK FOOTER //
// resources/layout/js/layout.js